package org.hs_soft.runmynesto.domain.model.home.closing_reports

import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.model.home.options.CountriesEnum
import org.hs_soft.runmynesto.domain.util.helper.LanguageManager
import org.jetbrains.compose.web.css.CSSSizeValue
import org.jetbrains.compose.web.css.CSSUnit


enum class CurrencyTableHeadersEnum(
    val defaultTitle: String,
    val arrangement: Arrangement.Horizontal = Arrangement.Start,
    val isNumeric: Boolean = false,
    val key: String
) {
    CURRENCY(
        defaultTitle = LanguageManager.getCurrentStrings().currency,
        key = "currency"
    ),
    LST(
        defaultTitle = LanguageManager.getCurrentStrings().lst,
        arrangement = Arrangement.End,
        isNumeric = true,
        key = "lst"
    ),
    COURSE(
        defaultTitle = LanguageManager.getCurrentStrings().course,
        arrangement = Arrangement.End,
        isNumeric = true,
        key = "course"
    ),
    CURRENCY_TYPE(
        defaultTitle = LanguageManager.getCurrentStrings().currency,
        arrangement = Arrangement.End,
        isNumeric = true,
        key = "currencyValue"
    ),
    CASH_DELIVERY(
        defaultTitle = LanguageManager.getCurrentStrings().cashDelivery,
        arrangement = Arrangement.End,
        isNumeric = true,
        key = "cashDelivery"
    ),
    DIFFERENCE(
        defaultTitle = LanguageManager.getCurrentStrings().difference,
        arrangement = Arrangement.End,
        isNumeric = true,
        key = "difference"
    ),
    AMOUNT(
        defaultTitle = LanguageManager.getCurrentStrings().amount,
        arrangement = Arrangement.End,
        isNumeric = true,
        key = "amount"
    ),
    AMOUNT_CHF(
        defaultTitle = LanguageManager.getCurrentStrings().amountCHF,
        arrangement = Arrangement.End,
        isNumeric = true,
        key = "amountCHF"
    );

    fun getTitle(companyProfileId: String?): String {
        return when (this) {
            CURRENCY_TYPE -> if (companyProfileId == CountriesEnum.SWITZERLAND.id)
                CurrencyTypeEnum.CHF.title
            else CurrencyTypeEnum.EUR.title
            else -> defaultTitle
        }
    }
}